export const LogoMark = ({ size = 40, variant = "light", className = "" }) => {
  const stroke = variant === "light" ? "#ffffff" : "#0d5b31";
  const id = variant === "light" ? "ak-light" : "ak-dark";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      className={className}
      role="img"
      aria-label="Angukumaran Farmhouse emblem"
      data-testid={`logo-mark-${id}`}
    >
      <g stroke={stroke} strokeWidth="2.6" strokeLinecap="round" fill="none">
        <circle cx="32" cy="32" r="24" />
        <path d="M32 14.5v-4.5" />
        <path d="M20 17.5l3 3" />
        <path d="M44 17.5l-3 3" />
        <path d="M13.5 30h5" />
        <path d="M45.5 30h5" />
        <path d="M16.5 44l4-2.4" />
        <path d="M47.5 44l-4-2.4" />
        <path d="M20 44.5l12-13 12 13" />
        <path d="M24.5 44.5v-5.5" />
        <path d="M39.5 44.5v-5.5" />
        <path d="M15.5 39.5c4.5-3.6 9.5-3.6 13.5 1" />
        <path d="M48.5 39.5c-4.5-3.6-9.5-3.6-13.5 1" />
        <path d="M17 49.5h30" />
        <path d="M23 54.5h18" />
        <path d="M32 38.5v6" />
      </g>
      <circle cx="32" cy="23.5" r="4.2" fill="#71a53a" stroke={stroke} strokeWidth="2.2" />
      <path
        d="M32 29.5c2.8 2.4 2.8 6 0 8.4-2.8-2.4-2.8-6 0-8.4z"
        fill={stroke}
      />
    </svg>
  );
};

export default LogoMark;
